var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataManagement(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 241,
    height: 196.998,
    viewBox: "0 0 241 196.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5648",
    "data-name": "Rectangle 5648",
    width: 17.645,
    height: 9.838,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10219",
    "data-name": "Group 10219",
    transform: "translate(-431.999 -581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Subtraction_347",
    "data-name": "Subtraction 347",
    transform: "translate(432 611)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231,167H10A10.011,10.011,0,0,1,0,157V10A10.011,10.011,0,0,1,10,0H81A43.059,43.059,0,0,0,84.142,16.25a41.756,41.756,0,0,0,8.572,13.27,39.818,39.818,0,0,0,12.714,8.947,38.586,38.586,0,0,0,31.14,0,39.819,39.819,0,0,0,12.715-8.947,41.756,41.756,0,0,0,8.572-13.27A43.059,43.059,0,0,0,161,0h70a10.011,10.011,0,0,1,10,10V157A10.011,10.011,0,0,1,231,167Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 230.9993896484375 165.9977416992188 C 235.9619903564453 165.9977416992188 239.9993286132812 161.9604034423828 239.9993286132812 156.9978179931641 L 239.9993286132812 9.998998641967773 C 239.9993286132812 5.036436080932617 235.9619903564453 0.9991234540939331 230.9993896484375 0.9991234540939331 L 161.9883117675781 0.9991234540939331 C 161.8703002929688 6.411539077758789 160.7933197021484 11.66375732421875 158.7824859619141 16.62559127807617 C 156.7201080322266 21.71493530273438 153.7670135498047 26.28615379333496 150.0052947998047 30.21231079101562 C 146.2407684326172 34.14131164550781 141.8558654785156 37.2265625 136.9724273681641 39.38234329223633 C 131.9129638671875 41.61584091186523 126.5386428833008 42.74831008911133 120.9987030029297 42.74831008911133 C 115.4588317871094 42.74831008911133 110.0845489501953 41.61584091186523 105.0251159667969 39.38234329223633 C 100.1417388916016 37.2265625 95.7569580078125 34.14131164550781 91.9925537109375 30.2122802734375 C 88.23098754882812 26.28621673583984 85.27802276611328 21.71499824523926 83.21567535400391 16.62559127807617 C 81.20492553710938 11.66375732421875 80.12798309326172 6.411539077758789 80.00997161865234 0.9991234540939331 L 9.999018669128418 0.9991234540939331 C 5.036425113677979 0.9991234540939331 0.999081552028656 5.036436080932617 0.999081552028656 9.998998641967773 L 0.999081552028656 156.9978179931641 C 0.999081552028656 161.9604034423828 5.036425113677979 165.9977416992188 9.999018669128418 165.9977416992188 L 230.9993896484375 165.9977416992188 M 230.9993896484375 166.9977416992188 L 9.999018669128418 166.9977416992188 C 4.485050201416016 166.9977416992188 -0.0009184570517390966 162.5118103027344 -0.0009184570517390966 156.9978179931641 L -0.0009184570517390966 9.998998641967773 C -0.0009184570517390966 4.485029697418213 4.485050201416016 -0.0008765258826315403 9.999018669128418 -0.0008765258826315403 L 80.99908447265625 -0.0008765258826315403 C 80.99908447265625 5.634904861450195 82.05632781982422 11.10215473175049 84.1424560546875 16.25003051757812 C 86.15702056884766 21.22149848937988 89.04111480712891 25.68631172180176 92.71461486816406 29.52046775817871 C 96.38808441162109 33.35456085205078 100.6658325195312 36.36481094360352 105.428955078125 38.467529296875 C 110.3603591918945 40.64449691772461 115.5987701416016 41.74831008911133 120.9987030029297 41.74831008911133 C 126.3986740112305 41.74831008911133 131.6371459960938 40.64449691772461 136.5685882568359 38.467529296875 C 141.3318634033203 36.36478042602539 145.6096801757812 33.35453033447266 149.2832336425781 29.52046775817871 C 152.9568634033203 25.686279296875 155.8410797119141 21.22146797180176 157.855712890625 16.25003051757812 C 159.9415740966797 11.10296726226807 160.9992065429688 5.635373592376709 160.9992065429688 -0.0008765258826315403 L 230.9993896484375 -0.0008765258826315403 C 236.5133972167969 -0.0008765258826315403 240.9993286132812 4.485029697418213 240.9993286132812 9.998998641967773 L 240.9993286132812 156.9978179931641 C 240.9993286132812 162.5118103027344 236.5133972167969 166.9977416992188 230.9993896484375 166.9977416992188 Z",
    stroke: "none",
    fill: "#31e5e5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9552",
    "data-name": "Group 9552",
    transform: "translate(280.002 -1298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    transform: "translate(243 1879)",
    fill: "#031f4f",
    stroke: "#31e5e5",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 29.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10025",
    "data-name": "Group 10025",
    transform: "translate(19528.516 11447)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6854",
    "data-name": "Path 6854",
    d: "M1.408,0H21.564a.456.456,0,0,0,.093.058,1.769,1.769,0,0,1,1.307,1.8q0,13.154,0,26.307A1.762,1.762,0,0,1,21.119,30H1.843A1.765,1.765,0,0,1,.007,28.181C0,27.6.019,27.009,0,26.424a.633.633,0,0,1,.262-.568C1.305,25,2.336,24.135,3.371,23.272L6.534,20.64c.074.082.139.152.2.224.753.859,1.5,1.721,2.258,2.578a.882.882,0,0,0,1.363.11q3.458-2.8,6.91-5.614a.88.88,0,1,0-1.117-1.351q-2.229,1.808-4.454,3.62L9.826,21.725C9,20.788,8.2,19.869,7.395,18.954a.9.9,0,0,0-1.446-.112Q3.09,21.221.233,23.6c-.061.05-.128.092-.226.162V20.311q0-9.2,0-18.4A1.772,1.772,0,0,1,1.343.052C1.368.044,1.386.018,1.408,0M9.261,7.045c1.62,0,3.239,0,4.859,0a.865.865,0,0,0,.337-1.672,1.672,1.672,0,0,0-.545-.071q-4.64-.006-9.279,0c-.088,0-.176,0-.263.009a.87.87,0,1,0,.12,1.737q2.386,0,4.771,0M6.633,9.719c-.723,0-1.445,0-2.168,0a.855.855,0,0,0-.906.832.846.846,0,0,0,.862.909q2.211.022,4.423,0A.872.872,0,1,0,8.8,9.72c-.723,0-1.445,0-2.168,0",
    transform: "translate(-19267 -9553)",
    fill: "#ffc450"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5637",
    "data-name": "Rectangle 5637",
    width: 22.966,
    height: 30,
    transform: "translate(-19267 -9553)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5646",
    "data-name": "Rectangle 5646",
    width: 7,
    height: 2,
    rx: 1,
    transform: "translate(-19263.518 -9543.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5647",
    "data-name": "Rectangle 5647",
    width: 12,
    height: 2,
    rx: 1,
    transform: "translate(-19263.518 -9547.9)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10058",
    "data-name": "Group 10058",
    transform: "translate(-19267 -9536.705)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10058-2",
    "data-name": "Group 10058",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6941",
    "data-name": "Path 6941",
    d: "M.256,9.619C1.3,8.756,2.329,7.88,3.364,7.009l3.162-2.66c.074.083.14.154.2.226.752.868,1.5,1.738,2.256,2.6a.982.982,0,0,0,1.364.113q3.457-2.833,6.908-5.672a.9.9,0,0,0,.186-1.3.884.884,0,0,0-1.3-.062q-2.228,1.826-4.453,3.657c-.619.509-1.24,1.016-1.871,1.534-.822-.948-1.624-1.876-2.431-2.8a1.032,1.032,0,0,0-1.444-.112Q3.082,4.936.226,7.342C.165,7.392.1,7.435,0,7.505V9.839Z",
    transform: "translate(0 0)",
    fill: "#ce720f"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataManagement);
export default __webpack_public_path__ + "static/media/DataManagement.f09da9db0b52e868db1abc0512e09212.svg";
export { ForwardRef as ReactComponent };